import { Link } from 'react-router-dom';

const services = [
  {
    icon: '🔍',
    title: 'SEO Services',
    desc: 'Show up when locals search for what you sell.',
    bullets: ['Fix site issues', 'Write helpful pages', 'Boost Google Business'],
    href: '/seo-services',
  },
  {
    icon: '🎯',
    title: 'PPC & Paid Media',
    desc: 'Run Google + Meta ads that bring ready-to-buy leads.',
    bullets: ['Pick winning keywords', 'Test ads & landing pages', 'Tune budgets daily'],
    href: '/ppc-services',
  },
  {
    icon: '💻',
    title: 'Web Development',
    desc: 'Build a fast, easy-to-understand website that converts.',
    bullets: ['Modern layouts', 'Clear calls-to-action', 'Tracking included'],
    href: '/web-development',
  },
  {
    icon: '✍️',
    title: 'Content Creation',
    desc: 'Plan and create content that educates and sells.',
    bullets: ['Monthly topics', 'Video + written assets', 'Posting plan'],
    href: '/content-creation',
  },
  {
    icon: '📱',
    title: 'Social Media Management',
    desc: 'Keep social channels active with on-brand stories.',
    bullets: ['Channel playbooks', 'Batch creative days', 'Comment + DM support'],
    href: '/social-media',
  },
  {
    icon: '✉️',
    title: 'Email & Lifecycle',
    desc: 'Send emails and texts that follow up and close the sale.',
    bullets: ['Welcome + nurture flows', 'Launch & promo emails', 'Deliverability tune-ups'],
    href: '/email-marketing',
  },
];

export default function Services({ onTalkClick }) {
  const handleNavigate = () => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  return (
    <section id="services" className="bg-white py-20">
      <div className="mx-auto max-w-6xl px-6">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Services</p>
        <h2 className="mt-2 text-3xl font-semibold md:text-4xl">Pick the lever you need right now</h2>
        <p className="mt-3 max-w-3xl text-slate-600">Pick what you need most now. We can layer on the rest later.</p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
          {services.map((service) => (
            <Link
              key={service.href}
              to={service.href}
              onClick={handleNavigate}
              className="group flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="text-3xl">{service.icon}</div>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">{service.title}</h3>
              <p className="mt-2 text-slate-600">{service.desc}</p>
              <ul className="mt-4 space-y-2 text-sm text-slate-700">
                {service.bullets.map((point) => (
                  <li key={point} className="flex items-start gap-2">
                    <span className="mt-1 inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              <span className="mt-6 inline-flex items-center text-sm font-semibold text-blue-600 transition group-hover:text-blue-700">
                Dive into {service.title.toLowerCase()} →
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <button
            onClick={onTalkClick}
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
          >
            Map my growth sprint →
          </button>
          <div className="flex flex-wrap gap-3 text-sm font-semibold">
            <Link
              to="/services"
              onClick={handleNavigate}
              className="inline-flex items-center rounded-full border border-slate-300 px-4 py-2 text-slate-700 transition hover:border-blue-500 hover:text-blue-600"
            >
              Services overview →
            </Link>
            <Link
              to="/projects"
              onClick={handleNavigate}
              className="inline-flex items-center rounded-full border border-slate-300 px-4 py-2 text-slate-700 transition hover:border-blue-500 hover:text-blue-600"
            >
              See live projects →
            </Link>
            <Link
              to="/blog"
              onClick={handleNavigate}
              className="inline-flex items-center rounded-full border border-slate-300 px-4 py-2 text-slate-700 transition hover:border-blue-500 hover:text-blue-600"
            >
              Read growth playbook →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
